import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'atyl-column',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.scss']
})
export class ColumnComponent implements OnInit {

  @Input() class: string;
  @Input() size: string = '12';
  @Input() offset: string = '';
  className: string = "";
  constructor() { }
  ngOnInit(): void {
    this.className = `col-${this.size} ${this.offset ? `offset-${this.offset}` : ''}`
    if (this.class!=undefined) 
		 this.className=this.class;
	
    
  }
}
